import React, { useContext } from 'react'
import { General } from '../tools/styles'
import FloatButton from '../components/ui/FloatButton'
import FloatCard from '../components/ui/FloatCard'
import { theme } from '../theme'
import { useNavigate } from 'react-router-dom'
import Current from '../components/Current'
import Generic from '../components/Generic'
import { waterAnalysis } from '../tools/water'
import styled from 'styled-components'
import { WatchContext } from '../WatchContext'
import handleInputChange from '../tools/handleInputChange'
import calcSedComplete from '../tools/calcSedComplete'
import BackToDash from '../components/BackToDash'

const Styles = {
  CapText: styled.span`
  text-transform: capitalize;
  font-weight: normal;
  `,
}

const Water = () => {
  const navigate = useNavigate()
  const { water, setWater } = useContext(WatchContext)

  const handleChange = ({ target }) => {

    let data = handleInputChange(water, target)

    data = waterAnalysis(data)

    let completeData = calcSedComplete(data)
    setWater(completeData);
  };

  return (
    <General.Background backgroundColor={`${theme.colors.pdeBlue + 40}`}>
      <General.Heading color={theme.colors.pdeBlue}>Water Chemistry</General.Heading>
      <BackToDash/>
      <Generic text={<Styles.CapText>{water.metric}</Styles.CapText>} title='Metric' />
      <Current
        currentValue={water?.currentValue}
        units={water?.units}
        just={water?.currentJust}
        handleChange={handleChange}
      />
      <General.BlockContainer align='center'>
        <General.Block>
          <FloatCard width="300px">
            <General.InputCont>
              <span>{water.salinityStatus.type || 'check your numbers'}</span>
            </General.InputCont>
          </FloatCard>
        </General.Block>
        <General.Block color={theme.colors.grey4}>
          <h2>Attribute Status</h2>
        </General.Block>
      </General.BlockContainer>
      <BackToDash/>
    </General.Background>
  )
}

export default Water